<template>
  <div class="wrap" :class="isCancel?'isHidden':''">
    <div class="patient_info">
      <ul>
        <li>
          <label>就诊医院</label>
          <span>{{hospital}}</span>
        </li>
        <li>
          <label>就诊科室</label>
          <span>{{department}}</span>
        </li>
        <li>
          <label>就诊医生</label>
          <span>{{employee}}</span>
        </li>
        <li>
          <label>就诊时间</label>
          <span>{{applyTimes}}</span>
        </li>
        <!-- <li>
          <label>预约定金</label>
          <span>12.00元</span>
        </li> -->
        <section></section>
        <li>
          <label>患者姓名</label>
          <span>{{nickName}}</span>
        </li>
        <li>
          <label>身份证号</label>
          <span>{{idNo}}</span>
        </li>
        <li>
          <label>手机号</label>
          <span>{{mobilePhone}}</span>
        </li>
      </ul>
    </div>

    <MaskTemp v-if="isCancel" @isCancelStatus="isCancelStatus" :resumeCancelNum="resumeCancelNum" :sendData="isCancel" :class="isCancel?'isHidden':''"></MaskTemp>

    <BtnFixed @click.native="cancelApply">取消预约</BtnFixed>

  </div>
</template>

<script>
  import MaskTemp from '@/components/doorHelp/MaskTemp'
  import { mapState } from 'vuex'
  import { userInfo } from '@/apis'
  import BtnFixed from '@/components/BtnFixed'
  import { order } from '@/apis'
  export default {
    data(){
      return {
        isCancel:false,
        patientDto:[],
        propsData:[],
        hospital:'',
        department:'',
        employee:'',
        applyTimes:'',
        times:'',
        nickName:'',
        idNo:'',
        mobilePhone:'',
        // orderNo: localStorage.getItem('orderNo'),
      }
    },
    props:['patientId','patientUUID','resumeCancelNum','orderNo'],
    components:{
      MaskTemp,
      BtnFixed
    },
    computed:mapState({
      openid: state => state.openid,
    }),
    watch:{
      patientDto(newval){
        this.nickName = newval.nickName;
        this.idNo = this.hideCenterNum(newval.idNo);
        this.mobilePhone = this.hideCenterNum(newval.mobilePhone);
      },
      propsData(newval){
        this.hospital = newval.info.hospital.name;
        this.department = newval.info.department.name;
        this.employee = newval.info.employee.name;
      }
    },
    created(){
      this.getOrderStatus()
      this.patientInfo()
    },
    mounted(){
    },
    methods:{
      getOrderStatus(){
        this.axios.get(order.orderStatus,{
          params:{
            patientId:this.patientId,
            patientUUID:this.patientUUID
          }
        }).then(res=>{
          if(res.status==200 && res.data.code=='000000'){
            this.propsData = res.data.data;
            this.getApplyTimes(this.propsData.info.day,this.propsData.info.period)
          }else{
            this.$toast(res.data.message)
          }
        })
      },
      // 触发取消预约按钮
      cancelApply(){
        this.isCancel = true;
      },
      isCancelStatus(data){
        this.isCancel = data;
      },
      getyyyyMMdd(date){
        let d = new Date(date);
        let curr_date = d.getDate();
        let curr_month = d.getMonth() + 1;
        let curr_year = d.getFullYear();
        String(curr_month).length < 2 ? (curr_month = "0" + curr_month): curr_month;
        String(curr_date).length < 2 ? (curr_date = "0" + curr_date): curr_date;
        let yyyyMMdd = curr_year + "-" + curr_month +"-"+ curr_date;
        return yyyyMMdd;
      },
      getApplyTimes(day,period){
        let timestr = ''+day
        timestr=timestr.substr(0,4)+'-'+timestr.substr(4,2)+'-'+timestr.substr(6,2)
        let noomn = period=='am'?'上午':'下午';
        this.applyTimes = timestr +' '+ noomn
      },
      patientInfo(){
        this.axios.get(userInfo.queryPatientsInfo,{
          params: {
            openId: this.openid,
          }
        }).then(res=>{
          this.patientDto = res.data.data.patientDto
        })
      },
      hideCenterNum(str){
        let newStr ='';
        let typestr = typeof str;
        if(typestr !='object'){
          for(let i=0;i<str.length-6;i++){
            newStr+='*'
          }
          newStr = str.substr(0,3)+newStr+str.substr(-3)
        }
        return newStr
      }
    },

  }
</script>

<style scoped lang="scss">
  .wrap{
    position: relative;
    background:$bgfff;
    @include width_height_100();
    .patient_info{
      ul{
        li{
          height:45px;
          line-height: 45px;
          padding:0 15px;
          @include layout_row_root();
          @include border-bottom(1px,solid,#EEEEEE);
          label,span{
            @include layout_row();
          }
          label{
            width:90px;
            @include text_font('PingFangSC',15px,normal,#666,left);
          }
          span{
            margin-left:5px;
            @include text_font('PingFangSC',15px,normal,#333,center);
          }
        }
        section{
          width:375px;
          height:7px;
          background:#F8F8F8;
        }
        div{
          padding:0 15px;
          @include text_font('PingFangSC',12px,normal,#AFAFAF,left);
        }
        .margin_top_10{
          margin-top:10px;
        }
      }
    }
  }
  .isNonePrevent{ touch-action: none; }
  .isHidden{
    overflow:hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/doorHelp/DetailTemp.vue